import { HasMetricaMetaRealizado, Metrica, MetricaValor } from '../modules/uteis/services/metrica.service';
import { LookupItem } from '../services/lookup.service';
import { Checklist } from './atividade.model';
import { Base } from './base.model';
import { CadeiaValor } from './cadeia-valor.model';
import { Comentario, HasComentarios } from './comentario';
import { Destinatario } from './destinatario.model';
import { Entrega } from './entrega.model';
import { Planejamento } from './planejamento.model';
import { PlanoEntregaEntrega } from './plano-entrega-entrega.model';
import { HasReacoes, Reacao } from './reacao';
import { UnidadeEntregaObjetivo } from './unidade-entrega-objetivo.model';
import { UnidadeEntregaProcesso } from './unidade-entrega-processo.model';
import { Unidade } from './unidade.model';

export type UnidadeEntregaTipoVinculo = "PARCELA" | "FILHA" | "COLATERAL" | "DEPENDENTE" | "NENHUM";

export type UnidadeEntregaStatus = "ATIVO" | "SUSPENSO" | "CONCLUIDO" | "CANCELADO";

export class UnidadeEntrega extends Base implements HasMetricaMetaRealizado, HasComentarios, HasReacoes {
    public entrega?: Entrega;
    public entrega_vinculada?: UnidadeEntrega;
    public unidade?: Unidade;
    public demandante?: Unidade;
    public planejamento?: Planejamento;
    public cadeia_valor?: CadeiaValor;
    public vinculadas?: UnidadeEntrega[];
    public entregas_plano_entrega?: PlanoEntregaEntrega[];
    public destinatarios?: Destinatario;

    public numero: number = 0;
    public data_inicio: Date = new Date();
    public data_fim: Date | null = null;
    public descricao: string = "";
    public destinatario: string = '';
    public metrica: Metrica = { tipo: "QUANTITATIVO" };
    public meta: MetricaValor = {};
    public realizado: MetricaValor = {};
    public realizado_complementar: MetricaValor | null = null;
    public tipo_vinculo: UnidadeEntregaTipoVinculo = "NENHUM";
    public comentarios: Comentario[] = []; /* Comentarios da entrega */
    public reacoes: Reacao[] = []; /* Reações da entrega */
    public etiquetas: LookupItem[] = []; /* Etiquetas */
    public checklist: Checklist[] = []; /* Checklist */
    public processos: UnidadeEntregaProcesso[] = [];
    public objetivos: UnidadeEntregaObjetivo[] = [];
    public status: UnidadeEntregaStatus = "ATIVO";

    public entrega_id: string = '';
    public entrega_vinculada_id: string | null = null;
    public unidade_id: string = '';
    public demandante_id: string = '';
    public destinatario_id: string | null = null;
    public planejamento_id: string | null = null;
    public cadeia_valor_id: string | null = null;

    public constructor(data?: any) { super(); this.initialization(data); }
}